module.exports = __webpack_public_path__ + "assets/img/2.1b1859ac.png";